import { Tooltip, Toast, Popover } from 'bootstrap';
import $ from "jquery";
import Tags from "./tags.js";
window.$ = window.jQuery = require('jquery');
Tags.init();

